<template>
	<v-container class="pa-4">
		<p class="display-1">
			{{ $t("title.locations") }}
		</p>
		<v-row class="fill-height" align="center">
			<template v-for="(item, i) in locations">
				<v-col :key="i" cols="6" sm="4" md="4">
					<v-card dark :width="minWidth" tile>
						<v-img
							:src="
								item && item.image_url
									? item.image_url
									: image_placeholder
							"
							:height="minHeight"
						>
						</v-img>
					</v-card>
					<h2 class="mt-2">{{ item.location_name }}</h2>
				</v-col>
			</template>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		props: ["locations", "image_placeholder", "location_count"],
		data() {
			return {
				transparent: "rgba(255, 255, 255, 0)",
			};
		},
		computed: {
			minHeight() {
				const height = this.$vuetify.breakpoint.mdAndUp ? "350px" : "200px";

				return `calc(${height} - ${this.$vuetify.application.top}px)`;
			},
			minWidth() {
				const width = this.$vuetify.breakpoint.mdAndUp ? "386px" : "300px";

				return `calc(${width} - ${this.$vuetify.application.top}px)`;
			},
		},
	};
</script>
<style scoped>
</style>